import { formatFullName } from './index';

export function buildManualCheckInOptions({ users, checkedInUserIds, currentUserId, youLabel }) {
  const checkedIn = new Set(checkedInUserIds);
  return users
    .filter(user => !checkedIn.has(user.id))
    .map(user => {
      const isCurrentUser = currentUserId && youLabel && user.id === currentUserId;
      const name = formatFullName(user, { labelInParenthesis: isCurrentUser ? youLabel : null });
      return {
        value: user.id,
        label: name || user.email,
        searchText: [formatFullName(user), user.email].filter(Boolean).join(' '),
      };
    });
}
